import script from "./LoadingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingPage.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingPage.vue?vue&type=style&index=0&id=4851e878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4851e878"]])

export default __exports__